import http from 'plugins/axios';

export default {
    getMiningRegularList(data) {
        return http.get({
            url: '/admin/mining/regular/list',
            data: data
        });
    },

    createOrUpdateMiningRegular(data) {
        return http.post({
            url: '/admin/mining/regular/createOrUpdate',
            data: data,
            dataType: 'form'
        });
    },

    updateMiningRegularStatus(data) {
        return http.post({
            url: '/admin/mining/regular/updateStatus',
            data: data,
            dataType: 'form'
        });
    },

    deleteMiningRegular(data) {
        return http.post({
            url: '/admin/mining/regular/delete',
            data: data,
            dataType: 'form'
        });
    },

    createOrUpdateMiningRegularCoin(data) {
        return http.post({
            url: '/admin/mining/regular/createOrUpdateRegularCoin',
            data: data
        });
    },

    getMiningRegularCoinList(data) {
        return http.get({
            url: '/admin/mining/regular/coinList',
            data: data
        });
    },

    getMiningRegularCoinOrderList(data) {
        return http.get({
            url: '/admin/mining/regular/order/list',
            data: data
        });
    },

    getMiningRegularCoinIncomeDetail(data) {
        return http.get({
            url: '/admin/mining/regular/order/incomeDetail',
            data: data
        });
    },

    calculateMiningRegularCoinIncomeDetail(data) {
        return http.post({
            url: '/admin/mining/regular/order/incomeCalculate',
            data: data,
            dataType: 'form'
        });
    },

    transferMiningRegularCoinIncomeDetail(data) {
        return http.post({
            url: '/admin/mining/regular/order/incomeTransfer',
            data: data,
            dataType: 'form'
        });
    },

    deleteRegularCoin(data) {
        return http.post({
            url: '/admin/mining/regular/deleteRegularCoin',
            data: data,
            dataType: 'form'
        });
    },

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
};
